;adc.gallery_detail = (function() {
    var

    isSearching = false,

    $mContainer = null;

    //
    //init
    //
    init = function() {
        $mContainer = $('.layout-gallery-detail');


        if ($mContainer.length > 0 || $('.layout-home').length > 0) {
            loadShareButtons();
            setupAudioLinkClick();
        }
    },

    //
    // Get the AddThis metadata and init the share buttons
    //
    loadShareButtons = function() {

        // set the options
        var addthis_share = {
            url: $('meta[property="og:url"]').attr('content'),
            title: $('meta[property="og:title"]').attr('content'),
            description: $('meta[property="og:description"]').attr('content'),
            media: $('meta[property="og:image"]').attr('content')
        };

        // init addthis share buttons
        addthis.toolbox('.addthis_toolbox', null, addthis_share);
    }

    //
    // Setup the click for an audio file by language
    //
    setupAudioLinkClick = function() {

        // click
        $('.audio-link').unbind('click');
        $('.audio-link').bind('click', function(e) {
            e.preventDefault();

            // get the clicked link, element, and audio
            var lnk = $(this);
            var elem = $(this).parent('.audio-language');
            var audio = $('audio[data-id=' + elem.attr('data-id') + ']');
            
            // hide the last audio
            $('audio[data-id!=' + elem.attr('data-id') + ']').hide();

            // show the new audio
            audio.show();

            // get the element for the last language (find one that doesn't have a link)
            var lastLanguage = $('.audio-language:not(:has(>a.audio-link))');
            lastLanguage.wrapInner('<a class="audio-link" href="#" />');

            // remove the link for the current language
            elem.html(lnk.text());

            // re-init the click events
            setupAudioLinkClick();

            return false;
        });
    }

    //call init
    $(document).ready(init);

    return {
        loadShareButtons: loadShareButtons,
        setupAudioLinkClick: setupAudioLinkClick
    }

})();